import { Component, createSignal, For, onMount, Show } from "solid-js"
import { Artwork, ListItem } from "../../types";
import { createStore } from "solid-js/store";
import { fetchGet, fetchPost } from "../../api";
import { ISelectEntityModalInstance, SelectEntityModal } from "../../components/select-entity/select-entity-modal";
import { DateTime } from "../../components/date-time";

type Props = {
    artwork: Artwork;
}
type Entity = {
    Id: string;
    Name: string;
    Description: string;
    IsDeleted: boolean;
    DateAddedUTC: string;
}

export const EntitiesTab : Component<Props> = ({ artwork }) => {
    const [selectedEntityId, setSelectedEntityId] = createSignal<string>("");
    const [entities, setEntities] = createStore<Entity[]>([]);
    let modal: ISelectEntityModalInstance;
    const loadEntities = async () => {
        const res = await fetchGet("/Artwork/GetEntitiesFromJson", { id: artwork.id });
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        setEntities(json.Data);
    }
    const onItemSelected = async (item: ListItem) => {
        setSelectedEntityId(item.Value);
    }
    const associateWithArtwork = async () => {
        const res = await fetchGet("/Artwork/AddEntityToJson", { artworkId: artwork.id, entityId: selectedEntityId() });
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        modal?.clear();
        await loadEntities();
    }
    const removeEntityFrom = async (item: Entity) => {
        const res = await fetchGet("/Artwork/RemoveEntityFromJson", { artworkId: artwork.id, entityId: item.Id });
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        await loadEntities();
    }
    onMount(async () => {
        await loadEntities();
    });
    return (
        <>
            <div>
                <h2>
                    Add/remove entities
                </h2>
                <div style="text-align: left; padding: 10px;">
                    <div style="display: inline-block;">
                        <SelectEntityModal
                            initialValue={{ Text: "", Value: "" }}
                            onItemSelected={onItemSelected}
                            setInstance={(inst) => { modal = inst }}
                        />
                    </div>
                    <div style="display: inline-block; margin-left: 10px;">
                        <button class="btn btn-primary" onClick={associateWithArtwork}>Associate</button>
                    </div>
                </div>
                <table class="table" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>
                                
                            </th>
                            <th>
                                Name
                            </th>
                            <th>
                                Description
                            </th>
                            <th>
                                Date added
                            </th>
                            <th>
                                Remove?
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <For each={entities}>{(item) =>
                            <tr>
                                <td>

                                </td>
                                <td>
                                    {item.Name}
                                </td>
                                <td>
                                    <DateTime value={item.DateAddedUTC} />
                                </td>
                                <td>
                                    <div innerHTML={item.Description || ""} />
                                </td>
                                <td>
                                    <button class="btn btn-danger" onClick={(e) => { e.preventDefault(); removeEntityFrom(item); }}>Remove</button>    
                                </td>
                            </tr>
                        }</For>
                    </tbody>
                </table>
            </div>
        </>
    )
}